import React, { Suspense } from 'react';
import tokens from '@atlaskit/tokens/token-names';
import { IconGlyphs } from './__generated__';
/**
 * The validateColor function and its helper functions could not be
 * moved to a seperate file because it could potentitally cause cyclic
 * dependencies since type IconColor must be defined here in order for
 * forge-react-types to recognise it.
 */
var iconTokenSet = new Set(Object.keys(tokens).filter(function (token) {
  return token.startsWith('color.icon');
}));
var isInTokenSet = function isInTokenSet(color) {
  return iconTokenSet.has(color);
};
export var validateColor = function validateColor(color) {
  if (!color) {
    return undefined;
  }
  if (!isInTokenSet(color)) {
    // eslint-disable-next-line no-console
    console.warn("".concat(color, " is not a valid icon color design token"));
    return undefined;
  }
  return "var(".concat(tokens[color], ")");
};
export var IconComponent = function IconComponent(_ref) {
  var glyph = _ref.glyph,
    size = _ref.size,
    label = _ref.label,
    primaryColor = _ref.primaryColor,
    secondaryColor = _ref.secondaryColor;
  var Component = IconGlyphs[glyph];
  if (!Component) {
    // eslint-disable-next-line no-console
    console.warn("Icon component ".concat(glyph, " not found"));
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(Component
  // @ts-ignore: Jira only - TS2322: Type '{ label: string; size: "small" | "medium" | "large" | undefined; glyph: Icon; primaryColor: string | undefined; secondaryColor: string | undefined; }' is not assignable to type 'IntrinsicAttributes'.
  , {
    label: label,
    size: size,
    glyph: glyph,
    primaryColor: validateColor(primaryColor),
    secondaryColor: validateColor(secondaryColor)
  }));
};

/**
 * An icon is a visual representation of a command, device, directory, or common action.
 */
export var Icon = function Icon(props) {
  var _ref2 = props.forgeDoc.props,
    size = _ref2.size,
    glyph = _ref2.glyph,
    label = _ref2.label,
    primaryColor = _ref2.primaryColor,
    secondaryColor = _ref2.secondaryColor;
  return /*#__PURE__*/React.createElement(IconComponent, {
    label: label,
    size: size,
    glyph: glyph,
    primaryColor: primaryColor,
    secondaryColor: secondaryColor
  });
};